import React from 'react'
import { format } from 'date-fns'
//import { ColumnFilter } from './ColumnFilter'

export const COLUMNS = [
  {
    Header: 'Kanal',
    accessor: 'offerChannel',
    //disableFilters: true,
    sticky: 'left',
   // Filter: ColumnFilter,
  },
  {
    Header: 'Uhr Info',
    accessor: d => <p>{d.brand} {d.model} {d.reference} <br></br> {d.hasBox? 'mit Box' : ''} {d.hasPapers? 'mit Papieren' : ''}</p>,
    sticky: 'left',
    disableSortBy: true,
  },
  {
    Header: 'Watch info2',
    accessor: d =>  `${d.brand} ${d.model} ${d.reference} ${d.hasBox? 'mit box' : ''} ${d.hasPapers? 'mit Papier' : ''}`,
    sticky: 'left',
  },
  {
    Header: 'Verkäufer Name',
    accessor: 'sellerName',
    sticky: 'left',
  },
  {
    Header: 'Preis',
      accessor: d => <p style={{ whiteSpace: 'nowrap' }}>{d.initialSellerPrice ? <>Verkäuferwunsch: {d.initialSellerPrice} EUR<br /></> : ''}Max. Preis: {d.maximumOfferPrice} EUR</p>,
    sticky: 'left',
    disableSortBy: true,
  },
  //{
  //  Header: 'Preis2',
  //  accessor: d => `Max Preis: ${d.maximumOfferPrice}   Initial Seller Price: ${d.initialSellerPrice ?   d.initialSellerPrice : ''} `,
  //  sticky: 'left',
  //  disableSortBy: true,
  //},
  {
    Header: 'Angebot von',
    accessor: d => `${d.offerMadeBy}`,
    sticky: 'left',
  },
  {
    Header: 'Angebot Datum',
    accessor: 'offerDate',
    sticky: 'left',
    Cell: ({ value }) => {
        return format(new Date(value), 'dd/MM/yyyy')
      },
      //sortType: "datetime"
  },
  {
    Header: 'Telefon',
    accessor: 'sellerPhone',
    sticky: 'left',
  },
  {
    Header: 'Verkäufer Email',
    accessor: 'sellerEmail',
    sticky: 'left',
  },

]

